//@ts-nocheck
import React from 'react';
import { Tooltip } from 'react-tippy';
function TemplateOverlay() {
    return (React.createElement("div", null,
        React.createElement(Tooltip, { title: "Click to select", trigger: "mouseenter", hideOnClick: true, delay: 300 },
            React.createElement("div", { className: "absolute inset-0 cursor-pointer z-10" }))));
}
export default TemplateOverlay;
